import * as userType from './userType';
import * as permissions from './permissions';
import * as user from './user';
export * from './user';

export * from './userType';
export * from './permissions';

const selectors = {
  ...userType,
  ...permissions,
  ...user
};

export default selectors;

